// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

export default interface ConnectionMetrics {
  uplinkKbps?: number;
  nackCountPerSecond?: number;
}
